import React from "react";
import { Star } from "lucide-react";

export const StarRating = ({ value = 0, size = 14, showValue = false, count = null, testId }) => {
    const rounded = Math.round(value * 2) / 2;
    return (
        <div className="inline-flex items-center gap-1.5" data-testid={testId}>
            <div className="inline-flex items-center">
                {[1, 2, 3, 4, 5].map((i) => {
                    const filled = i <= rounded;
                    const half = !filled && i - 0.5 === rounded;
                    return (
                        <span key={i} className="relative inline-block" style={{ width: size, height: size }}>
                            <Star size={size} className="star-empty" strokeWidth={1.5} />
                            {(filled || half) && (
                                <span
                                    className="absolute inset-0 overflow-hidden"
                                    style={{ width: half ? size / 2 : size }}
                                >
                                    <Star size={size} className="star-filled fill-current" strokeWidth={1.5} />
                                </span>
                            )}
                        </span>
                    );
                })}
            </div>
            {showValue && (
                <span className="text-xs font-mono text-[var(--text-secondary)]">
                    {value.toFixed(1)}
                    {count !== null && ` (${count})`}
                </span>
            )}
        </div>
    );
};
